// filepath: /Users/thomasgaggl/Softline/development/nx/libs/framework/core/src/lib/date/functions/manupulation/start-of/start-of-hour.function.ts
import { isIsoDate } from '../../validation/is-iso-date.function';
import { isIsoDateTime } from '../../validation/is-iso-date-time.function';
import { isIsoDateTimeTz } from '../../validation/is-iso-date-time-tz.function';
import { getTimeOffset } from '../../get/get-time-offset.function';
import { IsoDateTime, IsoDateTimeTz, IsoTime, IsoTimeTz } from '../../../types/iso-date';
import { deconstructDate } from '../../helper/deconstruct-date.function';
import { constructDate } from '../../helper/construct-date.function';

/**
 * Returns the start of the hour for the given ISO input.
 * - For date-time without tz (YYYY-MM-DDTHH:mm:ss[.fraction]) -> 'YYYY-MM-DDTHH:00:00.000'
 * - For date-time with tz (YYYY-MM-DDTHH:mm:ss[.fraction](Z|±HH:MM)) -> 'YYYY-MM-DDTHH:00:00.000Z|±HH:MM'
 * Throws for date-only inputs (YYYY-MM-DD) and invalid formats.
 */
export function startOfHour<T extends IsoDateTime | IsoDateTimeTz | IsoTime | IsoTimeTz>(input: T): T {
  const deconstructed = deconstructDate(input);
  if (deconstructed._type !== 'dateTime'
    && deconstructed._type !== 'dateTimeTz'
    && deconstructed._type !== 'time'
    && deconstructed._type !== 'timeTz') {
    throw new Error('startOfHour: invalid ISO date/time string');
  }
  deconstructed.minutes = 0;
  deconstructed.seconds = 0;
  deconstructed.milliseconds = 0;
  return constructDate(deconstructed) as unknown as T;
}

